import theme from '@styles/theme';
export default {
  container: {
    position: 'absolute',
    width: '100%',
    zIndex: theme.zIndex.modalDown,
    display: 'flex',
    top: 0,
    left: 0,
    mt: ['48px', '48px', '48px', '48px', '100px']
  },
  popupsContainer: {
    width: '100%',
    padding: ['0 16px', '0 16px', '0 24px', '0 24px', '0 40px'],
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column'
  },
  popup: (isActive: boolean) => ({
    transition: `transform ${theme.transitions.time.normal} ${theme.transitions.animation.atomCurve}`,
    transform: isActive ? 'translateX(0)' : 'translateX(calc(100% + 40px))',
    mb: ['24px', '24px', '24px', '24px', '0']
  })
};